<template>
  <div class="space-y-8">
    <BaseCard>
      <BaseCardBody>
        <div class="space-y-4">
          <component
            v-for="property in properties"
            :key="property.name"
            :is="property.component"
            :value="accProductTemplate[property.name]"
            v-bind="property.props"
          />
          <MediaManager :acc-product-template-id="accProductTemplateId" />
        </div>
      </BaseCardBody>
    </BaseCard>

    <DeleteProduct :acc-product-template-id="accProductTemplateId" />
  </div>
</template>

<script>
import MediaManager from './MediaManager.vue';
import DeleteProduct from './DeleteProduct.vue';

export default {
  inject: ['updateAccProductTemplate'],
  components: {
    MediaManager,
    DeleteProduct,
  },
  props: {
    accProductTemplateId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      showActions: false,
      properties: [
        {
          name: 'name',
          component: () => import('./StringProperty.vue'),
          props: {
            label: 'Name',
            name: 'name',
            rules: 'max:255',
            saveAction: this.updateAccProductTemplate,
            inputClasses: 'w-2/3',
          },
        },
        {
          name: 'shortDescription',
          component: () => import('./TextProperty.vue'),
          props: {
            label: 'Short description',
            name: 'shortDescription',
            rules: 'max:500',
            saveAction: this.updateAccProductTemplate,
          },
        },
      ],
    };
  },
  computed: {
    accProductTemplate() {
      return this.$store.state.entities.accProductTemplates.byId[this.accProductTemplateId];
    },
  },
};
</script>
